import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { userAPI } from '../services/api';
import './WarningModal.css';

type Warning = {
  id: number;
  reason: string;
  note: string | null;
  created_at: string;
};

/**
 * Globálny blokujúci modal — ak má prihlásený používateľ
 * neprečítané upozornenie od admina, musí ho potvrdiť
 * pred ďalším používaním aplikácie.
 */
export function WarningModal() {
  const location = useLocation();
  const [warning, setWarning] = useState<Warning | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // Nezobrazovať na public stránkach
    const publicPaths = ['/', '/login', '/register', '/forgot-password', '/reset-password',
      '/verify-email', '/account-banned', '/admin'];
    if (publicPaths.some(p => location.pathname === p || location.pathname.startsWith(p + '/'))) {
      return;
    }
    const token = localStorage.getItem('token');
    if (!token) return;

    userAPI.getPendingWarning()
      .then(res => {
        if (res.data?.warning) setWarning(res.data.warning);
      })
      .catch(() => {});
  }, [location.pathname]);

  const handleAcknowledge = async () => {
    if (!warning) return;
    setSubmitting(true);
    try {
      await userAPI.acknowledgeWarning(warning.id);
      setWarning(null);
    } catch {
      setSubmitting(false);
    }
  };

  if (!warning) return null;

  return (
    <div className="wm-overlay">
      <div className="wm-card">
        <h2 className="wm-title">Upozornenie od administrátora</h2>

        <div className="wm-box">
          <p className="wm-label">Dôvod:</p>
          <p className="wm-reason">{warning.reason}</p>
          {warning.note && <p className="wm-note">{warning.note}</p>}
        </div>

        <p className="wm-hint">
          Prečítaj si naše pravidlá komunity. Pri opakovanom porušení bude účet zablokovaný.
        </p>

        <button className="wm-btn" onClick={handleAcknowledge} disabled={submitting}>
          {submitting ? 'Odosielam...' : 'Rozumiem a potvrdzujem'}
        </button>
      </div>
    </div>
  );
}
